<template>
  <div>
    <slot name="title">
      <h5 v-if="smallerTitle">
        {{ subTitle || title }}
      </h5>
      <h3 v-else>
        {{ title }}
      </h3>
    </slot>
    <p v-if="!hideTip">
      {{ helpfulTip }}
    </p>
    <slot />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import wrapperProps from '@/components/builder/UI/wrapperProps'

const props = wrapperProps

@Component
export default class HeadingWrapper extends Vue.extend({ props }) {}

</script>
